import type { HomePageV2TeamMember } from "../contentTypes";
import renata from "../../../assets/homePageV2/Renata.png";
import rogerio from "../../../assets/homePageV2/Rogerio.png";
import dutra from "../../../assets/homePageV2/Dutra.png";

export const porTrasDoPastejoContent: {
  heading: string;
  intro: string;
  team: HomePageV2TeamMember[];
} = {
  heading: "POR TRÁS DO PASTEJO",
  intro:
    "O Pastejo nasce da experiência de profissionais que conhecem a pecuária de corte na prática e entendem, de forma profunda, os desafios da operação dentro da porteira.",
  team: [
    {
      name: "Renata Gois",
      bio: "Zootecnista (UFMT), mestre pelo IF Goiano e doutoranda em Biotecnologia pela UFR. Criada em fazenda no interior de Mato Grosso, construiu uma trajetória que une vivência real no campo com rigor técnico em grandes projetos de gado de corte. No Pastejo, atua como Product Owner e é quem traduz os desafios operacionais do produtor em soluções digitais que funcionam de verdade.",
      image: renata,
    },
    {
      name: "Rogério Fonseca Guimarães Peres",
      bio: "Médico veterinário (UFU), mestre e doutor em Produção de Ruminantes (UNESP), MBA em Gestão (USP) e formação pelo AGRO CEO da ESALQ. Filho de produtores rurais e apaixonado pela pecuária desde criança, acumulou mais de 21 anos de experiência com visitas técnicas em seis países. Cofundador do Pastejo, lidera estratégia de mercado com a convicção de que fazenda de excelência começa com decisões bem fundamentadas e gente capacitada.",
      image: rogerio,
    },
    {
      name: "Rodrigo Costa Dutra",
      bio: "Bacharel em Sistemas de Informação (Unitri), especialista em Engenharia da Computação (PUC Minas), com mais de 20 anos em tecnologia, de grandes bancos a projetos de transformação digital no Brasil e no exterior. Filho de produtor rural, é um perfil raro no agro: entende da porteira para dentro e dos sistemas que a sustentam. Cofundador e Head Tech do Pastejo, constrói a plataforma com a robustez de quem veio do mercado financeiro e a sensibilidade de quem cresceu no campo.",
      image: dutra,
    },
  ],
};
